import { makeApi } from "@zodios/core";
import { z } from "zod";

import { simplifiedNodeDesignsStateSchema } from "@skilitics/nautilus-core-designer-data/schemas";

import { moduleSchema } from "./interactModules.ts";

const transportPayloadSchema = z.object({
  content: z.object({
    nodeDesigns: simplifiedNodeDesignsStateSchema, // needed because large payloads are very slow otherwise due to z.lazy etc. TODO reassess with zod 4?
    contentLanguages: z.array(
      z.object({
        code: z.string(),
        baseCode: z.string().nullish(),
      }),
    ),
    primaryContentLanguage: z.string(),
    revision: z.number(),
    appVersion: z.string(),
  }),
  metadata: moduleSchema,
});

export const transportApi = makeApi([
  {
    method: "get",
    path: "/transport/export/:hostId",
    alias: "exportModule",
    parameters: [
      {
        type: "Path",
        name: "hostId",
        schema: z.string(),
      },
    ],
    response: transportPayloadSchema,
    errors: [
      {
        status: 404,
        schema: z.string(),
      },
    ],
  },
  {
    method: "post",
    path: "/transport/import",
    alias: "importModule",
    parameters: [
      {
        type: "Query",
        name: "retainVersioning",
        schema: z.boolean().optional(),
      },
      {
        type: "Body",
        name: "payload",
        schema: transportPayloadSchema,
      },
    ],
    response: z.object({ hostId: z.string() }),
    status: 201,
  },
]);
